import type { TSettingsMenuItem } from '@components/Settings/models/settings.model';
import styles from './SettingsItem.module.css';
const SettingsItem = ({ onClick, Icon, label }: TSettingsMenuItem) => {
  return (
    <li role='menuitem' onClick={onClick} className={styles.item}>
      <div className={styles.icon}>
        <Icon />
      </div>

      {label}
    </li>
  );
};
export default SettingsItem;
